export type ClientRectLike = {
  left: number
  top: number
  width: number
  height: number
}

export type PageRect = { x: number; y: number; width: number; height: number }

export type PageFrame = {
  rect: ClientRectLike
  zoom: number
  borderLeft: number
  borderTop: number
  paddingLeft: number
  paddingTop: number
}

export const toPageSpace = (
  rect: ClientRectLike,
  page: PageFrame,
): PageRect => ({
  x:
    (rect.left - page.rect.left) / page.zoom -
    page.borderLeft -
    page.paddingLeft,
  y: (rect.top - page.rect.top) / page.zoom - page.borderTop - page.paddingTop,
  width: rect.width / page.zoom,
  height: rect.height / page.zoom,
})

export const roundPageRect = (rect: PageRect, decimals = 2): PageRect => {
  const factor = 10 ** decimals
  const round = (n: number) => Math.round(n * factor) / factor
  return {
    x: round(rect.x),
    y: round(rect.y),
    width: round(rect.width),
    height: round(rect.height),
  }
}

export const offsetPageRect = (
  rect: PageRect,
  origin: { x: number; y: number },
): PageRect => ({
  x: origin.x + rect.x,
  y: origin.y + rect.y,
  width: rect.width,
  height: rect.height,
})

const px = (value: string): number => Number.parseFloat(value) || 0

export const pageFrameOf = (pageEl: HTMLElement): PageFrame | null => {
  const rect = pageEl.getBoundingClientRect()
  if (!(rect.width > 0) || !(pageEl.offsetWidth > 0)) return null
  const zoom = rect.width / pageEl.offsetWidth
  if (!(Number.isFinite(zoom) && zoom > 0)) return null
  const cs = getComputedStyle(pageEl)
  return {
    rect: {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
    },
    zoom,
    borderLeft: px(cs.borderLeftWidth),
    borderTop: px(cs.borderTopWidth),
    paddingLeft: px(cs.paddingLeft),
    paddingTop: px(cs.paddingTop),
  }
}
